import React, { Component, Fragment, useEffect } from 'react';
import { Navigationmenu } from '../components';
import CircularProgress from '@material-ui/core/CircularProgress'
import ReactSession from '../reactclient.js';
import { withRouter } from 'react-router-dom';
import circulargridimage from '../gallery/gridloader.gif';
import Wrappercontainer from "../components/Wrappercontainer"
import { fnPostapiResponse, fnGETapiResponse, Fnencryption } from '../APICall';
import DatePicker from 'react-datepicker';
import moment, { max } from 'moment';
// import 'react-datepicker/dist/react-datepicker.css';

import Footer from '../components/Footer';




import {
    Box,
    Button,
    Typography,
    Grid,
    TextField,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    FormControl,
    Divider,
    Select,
    InputLabel,
    MenuItem,
    Popover,
    Tabs,
    Tab,
    DialogActions,
    withStyles,
    Slide,
    Dialog,
    AppBar,
    TableFooter, ListItemText, FormLabel, Checkbox
} from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import CloseIcon from '@material-ui/icons/Close';
import Toolbar from "@material-ui/core/Toolbar";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Tooltip from '@material-ui/core/Tooltip';
import Labelcontrol from "../components/Labelcontrol";

import { FileCopy, Refresh, Add, Delete, Edit } from '@material-ui/icons';


import {
    SearchOutlined,
    ArrowDropDown,
    Publish,
    NoteAdd,
    ArrowDropUp,
    InsertDriveFileOutlined,
    QueryBuilderTwoTone
} from '@material-ui/icons';
import { DataGrid } from '@material-ui/data-grid';


import {
    ALTERNATEROW_BACKGROUND_COLOR,
    BLUE_COLOR, LIGHTGRAY_COLOR,
    MODIFIEDBLACK,
    PINK_COLOR,
    PROTECT_GREEN,
    RED_COLOR,
    VIBRANT_GREEN, DARKGREEN_COLOR,
    LIGHTGREEN_COLOR
} from "../constants";
import Switch from '@material-ui/core/Switch';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import List from "@material-ui/core/List";
import renderIf from 'render-if';
import { Redirect } from "react-router-dom";
import axios from "axios"
import { IdleTimeOutModal } from '../components/Logoutmodal';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { ExportExcel } from './ExportExcel';

const StyledTabs = withStyles({
    indicator: {
        display: 'flex',
        backgroundColor: 'white',
        height: 3
    },
}, { index: 1 })((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);
const SomeComponent = withRouter(props => <Maintenance {...props} />);
const StyledTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        color: 'white',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        '&:focus': {
            opacity: 1
        }
    },
}, { index: 1 }))((props) => <Tab disableRipple {...props} />);
  var columns= [
    { field: 'NIC', headerName: 'NIC', width: 120 },
    { field: 'SNAME', headerName: 'SURNAME', width: 200 },
    { field: 'FNAME', headerName: 'FIRST NAME', width: 200 },
    { field: 'ADDR1', headerName: 'ADDRESS', width: 150 },
    { field: 'BSOURCE', headerName: 'SOURCE', width: 150 },
    { field: 'NIC_CNTRY', headerName: 'COUNTRY', width: 150, },
    { field: 'LINE_OF_CONTROL', headerName: 'LINE OF CONTROL', width: 220 },
    { field: 'ISSUEDATE', headerName: 'ISSUE DATE', width: 180 },
    { field: 'EXPIRYDATE', headerName: 'EXPIRY DATE', width: 180 },
    { field: 'REVIEWDATE', headerName: 'REVIEW DATE', width: 180 },
    { field: 'LSTRNWDATE', headerName: 'TRANS DATE', width: 180 },
    { field: 'USERID', headerName: 'TRANSUSER', width: 180 },
    { field: 'SETNO', headerName: 'SETNO', width: 150 },
    { field: 'BTITLE', headerName: 'TITLE', width: 150 },
    { field: 'REMK1', headerName: 'REMARK', width: 180 },


]
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;

});

// function MyExportButton() {
//     return (
//         <GridToolbarContainer>
//             <GridToolbarExport />
//         </GridToolbarContainer>
//     );
// }
export default class Maintenance extends Component {
    constructor(props) {
        super(props);
    this.state = {
        tablebuffer: [],
        pages: 0,
        alldata:[],
        current: 1,
        records: 0,
        pageSize: 5,
        showPager: false,
        SOURCE: "",
        FNAME: "",
        IsWindowsAuth: "",
        SNAME: "",
        SNAMElabel: "",
        NICselectedlabel: "Business Registration Number",
        DOB: "",
        DBUserName: "",
        DBPassword: "",
        DBSource: "",
        DBProvider: "",
        test: false,
        isloading: false,
        pagesObj: [],
        selectedUser: "",
        newOBJ: [],
        selectedPass: "",
        ClientType: [],
        CompanyType: [],
        NATIONALITY: [],
        GENDER: [],
        country: [],
        SelectedClientType: "",
        SelectedCompany: '',
        SelectedClientName: "",
        selectedPassDROP: "",
        ispassdrp: false,
        isclntIndv: false,
        lblnationality: "",
        amlgender: "M",
        selectedOption: true,
        caseid: "",
        selectedCountry: "MUS",
        ismandatory: false,
        pageloadingdata: 0,
        nicvaliderror: "",
        todayDate: "",
        displayastric: "none",
        displayclose: "none",
        redirect: false,
        direction: "Maintenance",
        showModal: false,
        isforeignSwitch: false,
        isforeignSwitchChecked: false,
        showViewer: false,
        isdisplayswitch: "block",
        displayForeign: "block",
        LISTTYPE: "AML Watchlist",
        SETNO: "",
        LINEOFCONTROL: "",
        TITLE: "",
        SURNAME: "",
        FORNAME: "",
        NIC: "NIC",
        NICTEXT:"NIC",
        REMARK: "",
        ADDRESS: "",
        VALIDFOR: "",
        VALIDTYPE: "",
        CHKGENRAL: "",
        CHKLIFE: false,
        CHKWEALTH: false,
        CHKPENSION: false,
        CHKSTOKBROKING: false,
        CHKNONSWAN: false,
        DESCRIPTION: "",
        processedValues: []
       

    }}
    handleRowClick(e) {
        // if(e.LockCheckId=="true")
        console.log("click row data ", e)
        // {
        //   this.setState({ disabledRowactions: true })
        // }
        // else{
        //   this.setState({ disabledRowactions: false })
        // }
        // console.log("Data ji  ye he", e)
        this.setState({ showViewer: true })
        // let invoiceBuff = [];
        // let pecBuff = [];
        // let supportingBuff = [];
        // this.state.vettingbuffer = [];
        // let allcomnt = [];
        // let readyToLoadInvoice = {};
        // let decision = true;
        // var billn = e.uniqueId 
        // var alldoc = {
        //   "QuotNum": billn
        // }

        // console.log("QuotNum", billn)
        // fnPostapiResponse(process.env.REACT_APP_SOURCE_URL, 'Api/Getbase64Details', alldoc, process.env.REACT_APP_MPORT).then((responseattac) => {
        //   fnPostapiResponse(process.env.REACT_APP_SOURCE_URL, 'Api/GetComments', alldoc, process.env.REACT_APP_MPORT).then((response) => {

        //     if (response.data["GridData"] = undefined) {
        //       alert("No record available for Selected Row")
        //       return
        //     }
        //     console.log("CommentData", response.data["CommentsDetails"][0][0])

        //     if (response.data["CommentsDetails"] != undefined) {
        //       allcomnt = response.data["CommentsDetails"][0].filter(item => item.IsQuery === false && item.IsDoctorComment !== true)
        //       var qbuf = response.data["CommentsDetails"][0].filter(item => item.IsQuery === true)
        //       var docbuff = response.data["CommentsDetails"][0].filter(item => item.IsDoctorComment === true)
        //       allcomnt.map(item => {

        //         this.state.vettingbuffer.push({ Id: item.Id, text: item.Remarks, CreatedBy: item.CreatedBy, CreatedDate: utils.formatDate(item.CreatedDate) })
        //       });
        //       qbuf.map(item => {
        //         this.state.querybuffer.push({ Id: item.Id, text: item.Remarks, CreatedBy: item.CreatedBy, CreatedDate: utils.formatDate(item.CreatedDate) })
        //       });
        //       docbuff.map(item => {
        //         this.state.DoctorCommentbuffer.push({ Id: item.Id, text: item.Remarks, CreatedBy: item.CreatedBy, CreatedDate: utils.formatDate(item.CreatedDate) })
        //       });
        //     }
        //     if (responseattac.data["Data"] != undefined) {
        //       this.setState({
        //         allfilesbuff: responseattac.data["Data"][0]
        //       })
        //       console.log("alldoucs",this.state.allfilesbuff)

        //       this.state.allfilesbuff.map(item => {
        //         var fileSplit = item.Filename.split("-")
        //         var fileType = item.Filename

        //         if (fileType.includes("INVOICE")) {
        //           invoiceBuff.push({ name: item.Filename, FileBase64: item.Data,CreatedBy:item.CreatedBy,CreatedDate:utils.formatDate(item.CreatedDate) });
        //         }
        //         else if (fileType.includes("DOC")) {
        //           supportingBuff.push(({ name: item.Filename, FileBase64: item.Data,CreatedBy:item.CreatedBy,CreatedDate:utils.formatDate(item.CreatedDate) }));
        //         }
        //         else {
        //           pecBuff.push(({ name: item.Filename, FileBase64: item.Data,CreatedBy:item.CreatedBy,CreatedDate:utils.formatDate(item.CreatedDate) }));
        //         }
        //       })

        //       console.log("newIncoice", invoiceBuff)
        //       console.log("newsupport", supportingBuff)
        //       console.log("newPEC", pecBuff)

        //       this.setState({
        //         showViewer: true, invoiceBuffer: invoiceBuff, CLINICREF: e.CLINICREF,
        //         BillNo: e.BILLNO,
        //         CLAIMNO: e.CLAIMNO,
        //         clinicselection: e.CLINICNAME,
        //         BILLTYPE: e.BILLTYPE,
        //         BillDate: e.BILLDATE == "" || e.BILLDATE == null ? "" :e.BILLDATE.split('T')[0],
        //         DISPLAYBILLDATE: utils.gethumanreaabledate(e.BILLDATE.split('T')[0]),
        //         INVOICEAMT: e.INVOICEAMT == "" || e.INVOICEAMT == "NaN" ? "0.00" : parseFloat(e.INVOICEAMT).toFixed(2),
        //         DISCOUNTAMT: e.DISCOUNTAMT == "" || e.DISCOUNTAMT == "NaN" ? "0.00" : parseFloat(e.DISCOUNTAMT).toFixed(2),
        //         NETAMOUNT: e.NETAMOUNT == "" || e.NETAMOUNT == "NaN" ? "0.00" : parseFloat(e.NETAMOUNT).toFixed(2),
        //         PCLDISALLOWEDAMOUNT: e.PCLDISALLOWEDAMOUNT == "" || e.PCLDISALLOWEDAMOUNT == "NaN" ? "0.00" : parseFloat(e.PCLDISALLOWEDAMOUNT).toFixed(2),
        //         GUARANTEEDAMOUNT: e.GUARANTEEDAMOUNT == "" || e.GUARANTEEDAMOUNT == "NaN" ? "0.00" : parseFloat(e.GUARANTEEDAMOUNT).toFixed(2),
        //         CLINICNAME: e.CLINICNAME,
        //         PANELPAIDAMOUNT: e.PANELPAIDAMOUNT,
        //         PATIENTPAYABLEAMOUNT: e.PATIENTPAYABLEAMOUNT,
        //         PATIENTPAIDAMT: e.PATIENTPAIDAMT == "" || e.PATIENTPAIDAMT == "NaN" ? "0.00" : parseFloat(e.PATIENTPAIDAMT).toFixed(2),
        //         WRITEOFFAMT: e.WRITEOFFAMT == "" || e.WRITEOFFAMT == "NaN" ? "0.00" : parseFloat(e.WRITEOFFAMT).toFixed(2),
        //         totaloutstanding: e.TOTALOUTSTANDING == "" || e.TOTALOUTSTANDING == "NaN" ? "0.00" : parseFloat(e.TOTALOUTSTANDING).toFixed(2),
        //         doctoroutstanding: e.OUTSTANDINGDOCTORALLOCATION == "" || e.OUTSTANDINGDOCTORALLOCATION == "NaN" ? "0.00" : parseFloat(e.OUTSTANDINGDOCTORALLOCATION).toFixed(2),
        //         hospitaloutstanding: e.OUTSTANDINGHOSPITALALLOCATION == "" || e.OUTSTANDINGHOSPITALALLOCATION == "NaN" ? "0.00" : parseFloat(e.OUTSTANDINGHOSPITALALLOCATION).toFixed(2),
        //         DATERECEIVED: e.DATERECEIVED.split('T')[0],
        //         DISPLAYRECDATE: utils.gethumanreaabledate(e.DATERECEIVED.split('T')[0]),
        //         DISPATCHDATES: e.DISPATCHDATES == "" || e.DISPATCHDATES == null ? "" :e.DISPATCHDATES.split('T')[0],
        //         pecstate: e.WILLWEPAY == true ? "true" : "false",
        //         nopayReason: e.NOTPAYREASON,
        //         alreadypaid: e.ALREADYPAID == true ? "true" : "false",
        //         amountpaid: e.PAIDAMOUNT == "" || e.PAIDAMOUNT == "NaN" ? "0.00" : parseFloat(e.PAIDAMOUNT).toFixed(2),
        //         DoctorComment: e.DOCTORREMARK,
        //         DoctorDisallowedAmount: e.DOCTORDISALLOWEDAMOUNT == "" || e.DOCTORDISALLOWEDAMOUNT == "NaN" ? "0.00" : parseFloat(e.DOCTORDISALLOWEDAMOUNT).toFixed(2),
        //         icdcode: e.ICD10CODE,
        //         scaleofcost: e.SCALEOFCOSTCODE,
        //         pecdocuments: pecBuff,
        //         policyNumber: e.POLICYNO,
        //         supportingdocuments: supportingBuff, showDocumentModifier: decision, patientname: e.PATIENTNAME,
        //         DataUniqueId:e.uniqueId,
        //         FAMILYID: e.FAMILYID,
        //         MEMBERID: e.MEMBERID,
        //         ADMISSIONDATE:  e.DATEOFADMISSION == "" || e.DATEOFADMISSION == null ? "" :e.DATEOFADMISSION.split('T')[0]
        //       });
        //     }
        //     this.SetFieldsEnableDisable(e.BILLTYPE)
        //     this.loaddefault(0)
        //   }).catch(e => console.log(e));
        // }).catch(e => console.log(e));


    }

    handleswitchchange(e, country) {
        if (this.state.SelectedClientType == "CORPORATE") {
            if (e && country != "MUS") {
                // debugger
                this.setState({
                    isdisplayswitch: "block", isforeignSwitchChecked: true,
                    NATIONALITY: [
                        {
                            "GRP_VALUES": "LEI",
                            "DESC50": "Legal entity identifier",
                            "ORDERING": "100",
                            "GRP_VALUE1": "CORPORATE"
                        },
                        {
                            "GRP_VALUES": "CRN",
                            "DESC50": "Company registration number",
                            "ORDERING": "120",
                            "GRP_VALUE1": "CORPORATE"
                        }

                    ], NICselectedlabel: "Legal entity identifier",
                    selectedPassDROP: "LEI", ispassdrp: true
                });
            } else {
                this.setState({ isdisplayswitch: "block", isforeignSwitchChecked: false, ispassdrp: false });
                this.FntocheckClienttype(this.state.SelectedClientType, this.state.SelectedCompany)
            }
        }
    }

    dialogWindowClose = () => {
        try {
            this.setState({ showViewer: false });
        } catch (error) {
            console.log(error)
        }
    }

    handleSomeDateChange(e) {
        if (new Date(e.target.value) > new Date()) {
            alert("DOB Can not be Greater then Today's Date")
            this.setState({ DOB: this.state.todayDate })
        }
        else {


            if (e.target.value == "")
                alert("Please select a valid date")
            else
                this.setState({ DOB: e.target.value })
        }
    }

    componentDidMount() {
        var date = new Date()
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
        var date1 = date.getDate() < 10 ? "0" + (date.getDate()) : date.getDate()
        var CMLSELECTEDATE = date.getFullYear() + "-" + month + "-" + date1
        this.state.todayDate = CMLSELECTEDATE

        //  this.setState({ DOB: "" })
        this.setState({ DOB: CMLSELECTEDATE, EXPIRYDATE: CMLSELECTEDATE, REVIEWDATE: CMLSELECTEDATE, TRANSDATE: CMLSELECTEDATE })

        this.state.selectedUser = sessionStorage.getItem('username')
        this.state.selectedPass = sessionStorage.getItem('password')
        this.state.IsWindowsAuth = sessionStorage.getItem('IsWindowsAuth')

        if (sessionStorage.getItem('isFromWindowApplication')) {
            //    if(process.env.REACT_APP_SOURCE_URL == "svr-vm-devtest")
            if (this.state.IsWindowsAuth) {
                this.setState({
                     DBSource: process.env.REACT_APP_ITC_DBSOURCE,
                     DBProvider: process.env.REACT_APP_ITC_DBPROVIDER,
                    test: false,
                    displayclose: "block"
                })
            }
            else {
                this.setState({
                    DBUserName: this.state.selectedUser,
                    DBPassword: Fnencryption(this.state.selectedPass),
                    DBSource:  process.env.REACT_APP_ITC_DBSOURCE,
                    DBProvider: process.env.REACT_APP_ITC_DBPROVIDER,
                    test: false,
                    displayclose: "block"
                })

            }

        }
        else {
            var data = {
                "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                "MAPINAME": 'GetDbVal',
                "MAPIPORT": '' + process.env.REACT_APP_MPORT + '',
                "body": ''
            }
            fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
                // console.log(response.data)
                if (response != undefined) {
                    this.setState({
                        DBUserName: this.state.selectedUser,
                        DBPassword: Fnencryption(this.state.selectedPass),
                        DBSource: response.data['Source'],
                        DBProvider: response.data['Provider'],
                        test: response.data['Test'],
                        displayclose: "none"
                    })
                }
                else {
                    alert(data)
                }

            }).catch(error => {
                console.log(error);
            })
        }
        this.getcmp()
         this.getsearch()

    }
    getcmp() {

        var data = {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GETAMLDETAILS',
            "MAPIPORT": '' + process.env.REACT_APP_MPORT + '',
            "body": ''
        }
        // console.log(data)
        fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            var data = response.data
            console.log(data)
            var cttype = sessionStorage.getItem('ClientType')
            if (cttype != "") {
                cttype = sessionStorage.getItem('ClientType').toUpperCase().trim()
                var Companytype = sessionStorage.getItem('Company').toUpperCase().trim()
                this.setState({
                    CompanyType: data["Company"][0],
                    ClientType: data["ClientType"][0],
                    country: data["Country"][0],
                    NATIONALITY: data["NATIONALITY"][0],
                    GENDER: data["Gender"][0],
                    SelectedCompany: Companytype,
                    SelectedClientType: cttype,
                });
                // this.fnsetclientType(this.state.SelectedClientType)

                this.setState({ SelectedCompany: Companytype })

            }
            else {
                this.setState({
                    CompanyType: data["Company"][0],
                    ClientType: data["ClientType"][0],
                    country: data["Country"][0],
                    GENDER: data["Gender"][0],
                    SelectedCompany: "SWAN GENERAL",
                    SelectedClientType: "CORPORATE",
                    lblnationality: "Country of Incorporation",
                    isclntIndv: true,
                    amlgender: "O",
                    SNAMElabel: "COMPANY NAME"
                });
                this.state.pageloadingdata = 1
            }

        }).catch(e => console.log(e));
    }
    getsearch() {
        this.state.pagesObj=[]
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GetBlacklistDetails',
            "MAPIPORT": '' + process.env.REACT_APP_MPORT1 + '',
            "body": {
                "databaseDetails": {
                    "DBUserName": sessionStorage.getItem('username'),
                    "DBPassword": sessionStorage.getItem('password'),
                    "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                    "DBProvider":process.env.REACT_APP_ITC_DBPROVIDER,
                    "Test": sessionStorage.getItem('IsTest'),
                    "IsWindowsAuth": true
                },
                "Sname": ""+this.state.SNAME+"",
                "Bsource": ""+this.state.SOURCE+"",
                "NIC": ""
            }

        }
         this.state.isloading = true
        // console.log(data)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response1) => {
             console.log("SearchDetails", response1.data)
            // var newdata;

            // newdata = response1.data

            // for (var i = 0; i < newdata.length; i++) {
            //     newdata[i].id = i
            // }
            // this.state.processedValues = response1.data
            this.setState({
                alldata: response1.data[0],isloading:false
            });
            this.renderpages()


            // console.log("all1", this.state.alldata  )
            // console.log("new 2process", newdata)
        }).catch(e => console.log(e),
        );
    }
    fetchDetails(rowObj) {
        //  console.log(rowObj)
        this.setState({
            FORNAME: rowObj['FNAME'],
            ADDRESS:rowObj['ADDR1'],
            SOURCE:rowObj['BSOURCE'],
            TITLE:rowObj['BTITLE'],
            TRANSUSER:rowObj['USERID'],
            LINEOFCONTROL:rowObj['LINE_OF_CONTROL'],
            SURNAME:rowObj['SNAME'],
            REMARK:rowObj['REMK1'],
            NICTEXT:rowObj['NIC'],
            SETNO:rowObj['SETNO']
            // selectedCountry:rowObj['NIC_CNTRY'],
        })
    
        this.setState({ showViewer:true});
    
        // POST request using fetch with error handling
      }

      clearPopup()
      {
        this.setState({
            FORNAME: "",
            ADDRESS:"",
            SOURCE:"",
            TITLE:"",
            TRANSUSER:"",
            LINEOFCONTROL:"",
            SURNAME:"",
            REMARK:"",
            NICTEXT:"NIC",
            selectedCountry:"MUS",
        })
    
        this.setState({ showViewer:true});
    
      }
    isEven(n) {
        return n % 2 == 0;
    }
    pageChange(number) {
        this.state.current = number;
        var data = this.state.alldata.slice(this.state.current * this.state.pageSize, (this.state.current + 1) * this.state.pageSize);
        this.setState({ tablebuffer: data })

        this.state.pagesObj = [];
        if (this.state.pages < 10) {
            for (var i = 0; i < this.state.pages; i++)
                this.state.pagesObj.push(i);
        }
        else {
            var min = this.state.current - 5;
            var max = this.state.current + 5;
            if (min < 0)
                min = 0;
            if (max > this.state.pages)
                max = this.state.pages;
            if (max - min > 10) {
                min = this.state.current - 5;
                max = this.state.current + 5;
            }
            if (min > 0)
                this.state.pagesObj.push(0);
            for (var i = min; i < max; i++)
                this.state.pagesObj.push(i);
            if (max < this.state.pages - 1)
                this.state.pagesObj.push(this.state.pages - 1);
        }
    }
    renderpages() {
        this.state.records = this.state.alldata.length;
        this.state.pages = parseInt(this.state.records / this.state.pageSize)
        if (this.state.records % this.state.pageSize > 0)
            this.state.pages++;
        this.state.showPager = this.state.pages > 1
        this.pageChange(0)
    }
    handleSerachChange(e, key) {
        this.setState({ key: e.target.value });
        this.state[key] = e.target.value;
    }
    handlefocusout(e) {
        this.FntocheckpassDrop(this.state.selectedPassDROP, e.target.value, this.state.selectedCountry)
        // // alert(this.state.caseid)
        // this.setState({
        //     nicvaliderror: ""
        // })

        // if (this.state.selectedPassDROP == "NIC")
        //     this.Nicchecking(e.target.value)
    }


    closetab = () => {
        var r = window.confirm("Do you want to logout?")
        if (r == true) {
            this.setState({
                redirect: true,
                direction: '/'
            })
        }

    }
    render() {

        return (

            <Fragment>
                {this.state.redirect &&
                    <Redirect to={this.state.direction} />
                }
                <Navigationmenu selectedMenu={'AMLSEARCH'} />

                <IdleTimeOutModal
                    showModal={this.state.showModal}
                    handleClose={this.handleClose}
                    handleLogout={this.handleLogout}

                />
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{ marginTop: 35 }}
                >
                    <Paper elevation={2} style={{ minHeight: 100, width: '90%', borderRadius: 6 }}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <div style={{  width: '98%', borderRadius: 6 }}>

                                <Grid container spacing={2} >
                                    <Grid item xs={11}>
                                        <div style={{
                                            display: 'flex',
                                            marginBottom: 20,
                                            marginTop: 60
                                        }}>
                                            <Typography style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 25, paddingLeft: 1 }}>
                                                SWAN Compliance WatchList</Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                        </Box>
                                    </Grid>
                                </Grid>

                                {/*FILTER DROPDOWNS*/}
                                <Grid container spacing={3} style={{ marginBottom: 30 }}>
                                    <Grid item xs={2}>
                                        <FormControl fullWidth >
                                            <TextField label="Surname"
                                                value={this.state.SNAME}
                                                onChange={(e) => this.handleSerachChange(e, "SNAME")}
                                                onBlur={e => this.setState({ SNAME: e.target.value.substring(0, 50) })}
                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={1}>

                                        <Select fullWidth
                                            variant={'outlined'}
                                            value={this.state.NIC}
                                            onChange={e => this.setState({ NIC: e.target.value })}
                                        >
                                            <MenuItem value={"NIC"}>NIC</MenuItem>
                                            <MenuItem value={"BRN"}>BRN</MenuItem>
                                            <MenuItem value={"CBR"}>CBR</MenuItem>
                                            <MenuItem value={"PHI"}>PHI</MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <TextField
                                            fullWidth label={this.state.NIC} value={this.state.NICVALUE}
                                            InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <FormControl fullWidth>
                                            <TextField
                                                fullWidth label="Source" value={this.state.SOURCE}
                                                onChange={(e) => this.handleSerachChange(e, "SOURCE")}
                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />

                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={2}>

                                        <Select fullWidth
                                            variant={'outlined'}
                                            value={this.state.LISTTYPE}
                                            onChange={e => this.setState({ LISTTYPE: e.target.value })}
                                        >
                                            <MenuItem value={"AML Watchlist"}>AML Watchlist</MenuItem>
                                            <MenuItem value={"AML Refinitiv"}>AML Refinitiv</MenuItem>
                                            <MenuItem value={"PEP Register"}>PEP Register</MenuItem>
                                            <MenuItem value={"BO Register"}>BO Register</MenuItem>
                                            <MenuItem value={"Negative List"}>Negative List</MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item xs={3} >
                                        <Button variant={'text'} onClick={(e) => this.getsearch("")} style={{ color: 'white', marginLeft: '2px', fontFamily: 'Globerbold', backgroundColor: VIBRANT_GREEN, width: '40%', fontSize: 18 }}>
                                            SEARCH
                                        </Button>
                                        <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "10px", backgroundColor: BLUE_COLOR, width: '40%', fontSize: 18 }}>
                                            CLEAR
                                        </Button> </Grid>
                                </Grid>
                                <br></br>
                                <div style={{  width: '100%' }}>
                                <TableContainer>
                                <Table aria-label="table">
                                        <TableHead style={{ backgroundColor: 'rgba(241,241,241,1.0)' }}>
                                            <TableRow>
                                                <TableCell style={{ borderWidth: 0, width: "150px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">NIC</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "150px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">First Name</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "150px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">Surname</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "100px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">Address</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">Source</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "100px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">Country</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "150px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">Line of Control</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">IssueDate</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">EXPIRY DATE</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">REVIEW DATE</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">TRANS DATE</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">TRANSUSER</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">SETNO</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">TITLE</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">REMARk</TableCell>
                                                {/* <TableCell style={{ borderWidth: 0, width: "90px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="left">SetNo</TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {!this.state.isloading ?
                                                this.state.tablebuffer.map((obj, index) => {
                                                    var rowbackgroundColor = 'white';
                                                    if (this.isEven(index)) { rowbackgroundColor = ALTERNATEROW_BACKGROUND_COLOR; }

                                                    if (this.state.ishovered && this.state.hoverindex == index) { rowbackgroundColor = LIGHTGRAY_COLOR }
                                                    if (obj != undefined) {
                                                        return (
                                                            <TableRow style={{ cursor: 'pointer' }} onClick={() => this.fetchDetails(obj)} key={index} hover={true} onMouseOut={() => this.setState({ ishovered: false })} onMouseEnter={() => this.setState({ hoverindex: index, ishovered: true })}>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj.NIC}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj.FNAME} </TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj.SNAME}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["ADDR1"]}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["BSOURCE"]}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["NIC_CNTRY"]}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["LINE_OF_CONTROL"]}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["LINE_OF_CONTROL"]}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["LINE_OF_CONTROL"]}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["LINE_OF_CONTROL"]}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["LINE_OF_CONTROL"]}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["LINE_OF_CONTROL"]}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["SETNO"]}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["BTITLE"]}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["REMK1"]}</TableCell>
                                                            </TableRow>
                                                        )
                                                    }
                                                })
                                                : <td style={{ marginLeft: "500px", height: "100px" }}>
                                                    {/* Loading.... <CircularProgress classes="CircularProgress" /> */}
                                                    <img style={{ width: "100px" }} src={circulargridimage} alt="circulargridimage" />;
                                                </td>}
                                        </TableBody>
                                    </Table>
                                    
                                </TableContainer><div style={this.state.showPager ? { height: 60, marginLeft: "500px", color: MODIFIEDBLACK, fontSize: "15px", textTransform: 'uppercase', fontFamily: 'Globerbold', wordBreak: "break-word" } : { display: "none" }} >
                                        {
                                            this.state.pagesObj.map((obj, index) => {
                                                return (
                                                    <span style={{ padding: "0 3px", cursor: "pointer" }}>
                                                        <a style={this.state.current == obj ? { fontWeight: 'bold', color: BLUE_COLOR, fontSize: "30px" } : {}} onClick={() => this.pageChange(obj)} >{obj + 1}</a>
                                                    </span>
                                                )
                                            })
                                        }
                                    </div>
                                </div>


                                <Divider></Divider>
                                <br></br>
                                Disclaimer: You are kindly advised that we will retain audit trails of searches made on the AML Watchlist for monitoring purposes.
                                <br></br>
                                <Grid item xs style={{ marginTop: '10px' }}>
                                    <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '160px', height: '40px' }}>
                                        View Swan Client
                                    </Button>
                                    &nbsp;&nbsp;
                                    {/* <Button variant={'text'}   style={{color:'white',fontFamily:'Globerbold',backgroundColor:BLUE_COLOR, width:'121px',height:'40px'}}>
                                                                Print Result
                                                    </Button> */}
                                    {/* <ExportExcel csvData={this.state.processedValues} fileName={'Download_Record'} /> */}
                                    &nbsp;&nbsp;
                                    <Button variant={'text'} onClick={() => this.clearPopup()} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, marginLeft: '700px', width: '121px', height: '40px' }}>
                                        ADD
                                    </Button>

                                </Grid>
                                {/* <Footer></Footer> */}
                                <br></br>
                                <Dialog fullScreen open={this.state.showViewer} onClose={() => this.dialogWindowClose()} TransitionComponent={Transition}>
                                    <Wrappercontainer large>
                                        <AppBar className={{ position: 'relative' }}>
                                            <Toolbar onClick={() => this.dialogWindowClose()}>
                                                <IconButton edge="start" color="inherit" aria-label="close">
                                                    <CloseIcon />
                                                </IconButton>
                                                <Typography style={{ flexGrow: 1 }} variant="h6" >
                                                    Compliance Lists Maintenance
                                                </Typography>
                                            </Toolbar>
                                        </AppBar>

                                        <Grid container={3} spacing={3}>
                                            <Grid item xs={12}>

                                                <div style={{ marginTop: 40, marginLeft: 20 }}>

                                                    <Grid container={8} spacing={3}>

                                                        {/* DETAILS OF BILLS ENCLOSED */}
                                                        <fieldset style={{ marginTop: "15px", width: "98%" }} >
                                                            <Grid container={3} spacing={3}>
                                                                <Grid item xs={12} md={6}>
                                                                    <TextField fullWidth={true} value={this.state.SETNO}
                                                                        onChange={e => this.setState({ SETNO: e.target.value })} variant={'outlined'} margin={'dense'} label={'Set No'} />
                                                                </Grid>
                                                                <Grid item xs={3} md={3}>

                                                                    <Select fullWidth style={{ height: '40px', marginTop: '8px' }}
                                                                        variant={'outlined'}
                                                                        value={this.state.LISTTYPE}
                                                                        onChange={e => this.setState({ LISTTYPE: e.target.value })}
                                                                    >
                                                                       <MenuItem value={"AML Watchlist"}>AML Watchlist</MenuItem>
                                            <MenuItem value={"AML Refinitiv"}>AML Refinitiv</MenuItem>
                                            <MenuItem value={"PEP Register"}>PEP Register</MenuItem>
                                            <MenuItem value={"BO Register"}>BO Register</MenuItem>
                                            <MenuItem value={"Negative List"}>Negative List</MenuItem>
                                                                    </Select>
                                                                </Grid>
                                                                <Grid item xs={3} md={3}>
                                                                    <Select fullWidth style={{ height: '40px', marginTop: '8px' }}
                                                                        variant={'outlined'}
                                                                        value={this.state.selectedCountry}
                                                                        onChange={e => this.setState({ selectedCountry: e.target.value })}
                                                                    >
                                                                        {this.state.country.map(team => (
                                                                            <MenuItem value={team.CODE}>{team.DESCRIPTION}</MenuItem>
                                                                        ))}g
                                                                    </Select></Grid>
                                                            </Grid>
                                                            <Grid container={3} spacing={3}>
                                                                <Grid item xs={12} md={6}>
                                                                    <TextField fullWidth={true} disabled={this.state.disabletext} value={this.state.SOURCE} onChange={e => this.setState({ SOURCE: e.target.value })} variant={'outlined'} margin={'dense'} label={'Source'} />
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <TextField fullWidth={true} disabled={this.state.disabletext} value={this.state.LINEOFCONTROL} onChange={e => this.setState({ LINEOFCONTROL: e.target.value })} variant={'outlined'} margin={'dense'} label={'Line of Control'} />
                                                                </Grid>
                                                                <Grid item xs={12} md={4}>
                                                                    <TextField fullWidth={true} value={this.state.TITLE}
                                                                        onChange={e => this.setState({ TITLE: (e.target.value) })} variant={'outlined'} margin={'dense'} label={'Title'} />
                                                                </Grid>
                                                                <Grid item xs={12} md={4}>
                                                                    <TextField fullWidth={true} disabled={this.state.disabletext} value={this.state.FORNAME} onChange={e => this.setState({ SOURCE: e.target.value })} variant={'outlined'} margin={'dense'} label={'Forename'} />
                                                                </Grid>
                                                                <Grid item xs={12} md={4}>
                                                                    <TextField fullWidth={true} disabled={this.state.disabletext} value={this.state.SURNAME} onChange={e => this.setState({ LINEOFCONTROL: e.target.value })} variant={'outlined'} margin={'dense'} label={'Surname'} />
                                                                </Grid>

                                                                <Grid item xs={12} md={4}>

                                                                    <TextField fullWidth={true} value={this.state.NICTEXT}
                                                                        onChange={e => this.setState({ NICTEXT: e.target.value })} variant={'outlined'} margin={'dense'} label={'NIC'} />
                                                                </Grid>


                                                            </Grid>
                                                        </fieldset>

                                                        <Grid container={3} spacing={3} style={{ marginTop: "10px" }}>
                                                            <Grid item xs={11} md={1} >

                                                                <label style={{ marginTop: "10px", fontSize: "14px", fontFamily: 'Globerbold', color: BLUE_COLOR }}> Remark</label>
                                                            </Grid>
                                                            <Grid item xs={11} md={11} >

                                                                <textarea rows={3} cols={150} fullWidth={true} disabled={this.state.disabletext} value={this.state.REMARK} onChange={e => this.setState({ REMARK: e.target.value })} variant={'outlined'} margin={'dense'} label={'Remark'} />
                                                            </Grid>

                                                            <Grid item xs={12} md={1} >
                                                                <label style={{ marginTop: "20px", fontSize: "14px", fontFamily: 'Globerbold', color: BLUE_COLOR }}> Address</label>

                                                            </Grid>
                                                            <Grid item xs={12} md={11} >

                                                                <TextField style={{ width: "94%" }} fullWidth={true} disabled={this.state.disabletext} value={this.state.ADDRESS} onChange={e => this.setState({ ADDRESS: e.target.value })} variant={'outlined'} margin={'dense'} label={''} />
                                                            </Grid>

                                                            <Grid item xs={12} md={1}>
                                                                <label style={{ fontSize: "14px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                                                    Issue Date
                                                                </label>    </Grid>
                                                            <Grid item xs={12} md={2}>
                                                                <TextField fullWidth id="date" disabled={this.state.isclntIndv} label=""
                                                                    type="date"
                                                                    value={this.state.DOB}
                                                                    className="form-control"
                                                                    variant="outlined"
                                                                    onChange={e => this.handleSomeDateChange(e)}
                                                                    inputProps={{
                                                                        max: "" + this.state.todayDate + ""

                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={1}>
                                                                <label style={{ fontSize: "14px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                                                    Expiry Date</label></Grid>
                                                            <Grid item xs={12} md={2}>
                                                                <TextField fullWidth id="date" disabled={this.state.isclntIndv} label=""
                                                                    type="date"
                                                                    value={this.state.EXPIRYDATE}
                                                                    className="form-control"
                                                                    variant="outlined"
                                                                    onChange={e => this.handleSomeDateChange(e)}
                                                                    inputProps={{
                                                                        max: "" + this.state.todayDate + ""

                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={1}>
                                                                <label style={{ fontSize: "14px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                                                    Review Date
                                                                </label></Grid>
                                                            <Grid item xs={12} md={2}>
                                                                <TextField fullWidth id="date" disabled={this.state.isclntIndv} label=""
                                                                    type="date"
                                                                    value={this.state.REVIEWDATE}
                                                                    className="form-control"
                                                                    variant="outlined"
                                                                    onChange={e => this.handleSomeDateChange(e)}
                                                                    inputProps={{
                                                                        max: "" + this.state.todayDate + ""

                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={3}>
                                                            </Grid>
                                                            <Grid item xs={12} md={2}>
                                                                <TextField fullWidth disabled={this.state.isclntIndv} label="Valid For"
                                                                    value={this.state.VALIDFOR}
                                                                    className="form-control"
                                                                    variant="outlined"

                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={3}>
                                                                <TextField fullWidth disabled={this.state.isclntIndv} label="Valid Type"
                                                                    value={this.state.VALIDTYPE}
                                                                    className="form-control"
                                                                    variant="outlined"

                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={1}>
                                                                <label style={{ fontSize: "14px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                                                    Tran Date</label></Grid>
                                                            <Grid item xs={12} md={2}>
                                                                <TextField fullWidth id="date" disabled={this.state.isclntIndv} label=""
                                                                    type="date"
                                                                    value={this.state.TRANSDATE}
                                                                    className="form-control"
                                                                    variant="outlined"
                                                                    onChange={e => this.handleSomeDateChange(e)}
                                                                    inputProps={{
                                                                        max: "" + this.state.todayDate + ""

                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={3}>
                                                                <TextField fullWidth disabled={this.state.isclntIndv} label="Tran User"
                                                                    value={this.state.TRANSUSER}
                                                                    className="form-control"
                                                                    variant="outlined"

                                                                />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container={3} spacing={3} style={{ marginTop: "10px" }}>

                                                            <Grid container spacing={2}>
                                                                <Grid item xs={2}>
                                                                    <label style={{ fontSize: "14px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                                                        <Checkbox name="CHKGENRAL" color="primary" checked={this.state.CHKGENRAL} onChange={e => this.setState({ CHKGENRAL: e.target.checked })} />
                                                                        General
                                                                    </label>
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <label style={{ fontSize: "14px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                                                        <Checkbox name="CHKLIFE" color="primary" checked={this.state.CHKLIFE} onChange={e => this.setState({ CHKLIFE: e.target.checked })} />
                                                                        Life
                                                                    </label>
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <label style={{ fontSize: "14px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                                                        <Checkbox name="CHKWEALTH" color="primary" checked={this.state.CHKWEALTH} onChange={e => this.setState({ CHKWEALTH: e.target.checked })} />
                                                                        Wealth
                                                                    </label>
                                                                </Grid>
                                                                <Grid item xs={2} >
                                                                    <label style={{ fontSize: "14px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                                                        <Checkbox name="CHKPENSION" color="primary" value={this.state.CHKPENSION} onChange={e => this.setState({ CHKPENSION: e.target.checked })} />
                                                                        Pensions
                                                                    </label>
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <label style={{ fontSize: "14px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                                                        <Checkbox name="CHKSTOKBROKING" color="primary" value={this.state.CHKSTOKBROKING} onChange={e => this.setState({ CHKSTOKBROKING: e.target.checked })} />
                                                                        Stockbroking
                                                                    </label>
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <label style={{ fontSize: "14px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                                                        <Checkbox name="CHKNONSWAN" color="primary" value={this.state.CHKNONSWAN} onChange={e => this.setState({ CHKNONSWAN: e.target.checked })} />
                                                                        Non Swan
                                                                    </label>
                                                                </Grid>
                                                                <Grid>

                                                                </Grid>
                                                                <Grid item xs={12} md={11} style={{ marginLeft: '10px' }}>

                                                                    <TextField fullWidth={true} disabled={this.state.disabletext} value={this.state.DESCRIPTION} onChange={e => this.setState({ DESCRIPTION: e.target.value })} variant={'outlined'} margin={'dense'} label={'Description'} />
                                                                    <Divider style={{ marginTop: '10px' }}></Divider>

                                                                    <Grid item xs style={{ marginTop: '10px' }}>
                                                                        <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '160px', height: '40px' }}>
                                                                            View Swan Client
                                                                        </Button>

                                                                        <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, marginLeft: '680px', width: '121px', height: '40px' }}>
                                                                            EDIT
                                                                        </Button>
                                                                        &nbsp;&nbsp;
                                                                        <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '121px', height: '40px' }}>
                                                                            Save
                                                                        </Button>
                                                                        &nbsp;&nbsp;
                                                                        <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '121px', height: '40px' }}>
                                                                            CANCEL
                                                                        </Button>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={6} md={6} style={{ marginTop: "7px" }} >
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            </Grid>

                                        </Grid>

                                    </Wrappercontainer>

                                </Dialog>
                            </div>
                        </Box>
                    </Paper>
                </Box>
            </Fragment>
        )
    }
}